export default __webpack_public_path__ + "static/media/banner_tickets_agenda_mobile.01781407.jpg";